const AUTHOR_COLORS = ['#e11d48', '#d97706', '#059669', '#0284c7', '#7c3aed', '#c026d3', '#0d9488', '#ea580c'];

export function authorColor(seed?: string | null): string {
  if (!seed) {
    return AUTHOR_COLORS[0];
  }
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return AUTHOR_COLORS[hash % AUTHOR_COLORS.length];
}
